import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  className?: string;
  hideOnHome?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({
  className = "",
  hideOnHome = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback to home if no history
      navigate("/");
    }
  };

  // Hide on home page if hideOnHome is true
  if (hideOnHome && location.pathname === "/") {
    return null;
  }

  return (
    <button
      onClick={handleBack}
      className={`fixed left-2 sm:left-3 md:left-4 top-20 sm:top-[70px] z-40 hidden sm:inline-flex items-center justify-center p-1.5 sm:p-2 rounded-xl bg-white/80 backdrop-blur-md shadow-md text-gray-600 hover:text-mango-600 hover:bg-white border border-gray-200/80 hover:border-mango-300 hover:shadow-glow transition-all duration-300 hover:-translate-x-0.5 active:scale-95 ${className}`}
      aria-label="Go back"
    >
      <ArrowLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0" />
    </button>
  );
};

export default BackButton;

